import Controller from "./authorization.controller";
import template from "./authorization.html";

const authorization = {
  template,
  controller: Controller,
};

export default authorization;



// WEBPACK FOOTER //
// ./src/pages/authorization/authorization.component.js